module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.0.0.box.186.546.1155.416.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.8.0.0.box.192.546.176.41.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.1.0.0"
    }
  }), _vm._v("PART I")]), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.1.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.8.0.1.box.186.785.1155.177.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.0.0"
    }
  }), _vm._v("Study ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.1.0"
    }
  }), _vm._v("Guide ")]), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.1.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.3.0.0"
    }
  }), _vm._v("By ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  }), _vm._v("Elizabeth ")]), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.13.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.14.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.15.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.16.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.17.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.18.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.19.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.20.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.21.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.22.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.23.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.24.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  }), _vm._v("Whitley ")]), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0.2"
    }
  }), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Roberson ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58b6aaf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0006.vue
// module id = 57
// module chunks = 0